import { Info } from "lucide-react";
import type { ReactNode } from "react";
import { TextD2C } from "../../elements/text-d2c/text";
import { cn } from "../../utils";

export interface NotificationAction {
  label: string;
  onClick: () => void;
}

export interface NotificationProps {
  message: ReactNode;
  action?: NotificationAction;
  icon?: ReactNode;
  className?: string;
  backgroundColor?: "neonchartreuse" | "alabastergrey";
}

export function Notification(props: Readonly<NotificationProps>) {
  const icon = props.icon ?? <Info className="mt-0.5 shrink-0" size={15} />;
  const backgroundColorClass =
    props.backgroundColor === "alabastergrey"
      ? "bg-alabastergrey"
      : "bg-neonchartreuse";

  return (
    <div
      className={cn(
        "flex items-start gap-2 self-stretch rounded-md p-4",
        backgroundColorClass,
        props.className
      )}
    >
      <span aria-hidden="true">{icon}</span>
      <div>
        <TextD2C color="black" style="no-mb" variant="p-small">
          {props.message}
        </TextD2C>

        {props.action && (
          <button
            className="mt-1 block text-sm underline"
            onClick={props.action.onClick}
            type="button"
          >
            {props.action.label}
          </button>
        )}
      </div>
    </div>
  );
}
